import React, { useState, useMemo, useEffect } from "react";
import { Select, MenuItem, Box } from "@mui/material";
import InsightTable from "Samarth Module/components/table/insightTable";
import styles from "./multiSelect.module.css";

const ProjectedORDropdown = ({ data }) => {
    const [selectedOption, setSelectedOption] = useState("All");
    const [selectedOptionLine, setSelectedOptionLine] = useState("All");
    const [selectedOptionSubformat, setSelectedOptionSubformat] = useState("All");
    const [finalData, setFinalData] = useState(data);
    const uniqueBasepack = useMemo(() => {
        const basepacks = data?.map(item => item.Basepack);
        return Array.from(new Set(basepacks)).filter(Boolean);
    }, [data]);
    const uniqueSubformat = useMemo(() => {
        const subformats = data?.map(item => item.Subformat);
        return Array.from(new Set(subformats)).filter(Boolean);
    }, [data]);
    const uniqueLine = useMemo(() => {
        let uniqueLineVal=[]
        const lines = data?.map((item) => {
            if(item.Line.includes(','))
            {
                const lineVal=item.Line.split(',')
                uniqueLineVal=[...uniqueLineVal,...lineVal]
            }
            else
            {
                uniqueLineVal=[...uniqueLineVal,item.Line]
            }
            
        });
        const uniqueArray = [...new Set(uniqueLineVal)];
        return Array.from(new Set(uniqueLineVal.map((item)=> item.trim()))).filter(Boolean);
    }, [data]);
    useEffect(()=>{
        const changedData = data.filter((item) => {
            return (
            (selectedOption === "All" || item.Basepack === selectedOption) &&
            (selectedOptionSubformat === "All" || item.Subformat === selectedOptionSubformat) &&
            (selectedOptionLine === "All" || item.Line.includes(selectedOptionLine.trim()))
            );
        });
        const filteredData=changedData.map((item) =>{
            const { Basepack,Subformat, ...rest } = item;
            return rest;
        });
        setFinalData(filteredData)
    },[selectedOption,selectedOptionLine,selectedOptionSubformat])
    return (
        <Box>
            <div style={{display:"flex",flexDirection:"row-reverse"}}>
                <div style={{display:"flex",flexDirection:"column"}}>
                    <div className={styles.dropdownContainer}>
                        <span className={styles.listItemHeader}>Basepack</span>
                    </div>
                    <div className={styles.menuItem}>
                        <Select
                            value={selectedOption}
                            onChange={(e) => setSelectedOption(e.target.value)}
                            size="small"
                            className={styles.selectedOption}
                        >
                            <MenuItem className={styles.listItem} value="All">Select</MenuItem>
                            {uniqueBasepack.map((basepack) => (
                                <MenuItem className={styles.listItem} key={basepack} value={basepack}>
                                    {basepack}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                </div>
                <div style={{display:"flex",flexDirection:"column"}}>
                    <div className={styles.dropdownContainer}>
                        <span className={styles.listItemHeader}>Line</span>
                    </div>
                    <div className={styles.menuItem}>
                        <Select
                            value={selectedOptionLine}
                            onChange={(e) => setSelectedOptionLine(e.target.value)}
                            size="small"
                            className={styles.selectedOption}
                        >
                            <MenuItem className={styles.listItem} value="All">Select</MenuItem>
                            {uniqueLine.map((line) => (
                                <MenuItem className={styles.listItem} key={line} value={line}>
                                    {line}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                </div>
                <div style={{display:"flex",flexDirection:"column"}}>
                    <div className={styles.dropdownContainer}>
                        <span className={styles.listItemHeader}>Subformats</span>
                    </div>
                    <div className={styles.menuItem}>
                        <Select
                            value={selectedOptionSubformat}
                            onChange={(e) => setSelectedOptionSubformat(e.target.value)}
                            size="small"
                            className={styles.selectedOption}
                        >
                            <MenuItem className={styles.listItem} value="All">Select</MenuItem>
                            {uniqueSubformat.map((item) => (
                                <MenuItem className={styles.listItem} key={item} value={item}>
                                    {item}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                </div>
            </div>
            <InsightTable type="Projected OR" data={finalData} />
        </Box>
    );
};

export default ProjectedORDropdown;

